/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../id_pair';
import '../creator_details';
import '../date';
import '../../items/items';
import './tender';
import './card_data';
import '../employee';
import '../../connect/v2/resources/address';
import '../../omg/model/orders';
import '../../connect/v2/common/tax_category';
import '../kds/models/models';
import './translated_name';
import '../../merchant/api';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "Cart": {
                "fields": {
                  "lineItems": {
                    "type": "squareup.client.bills.Cart.LineItems",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": "squareup.client.bills.Cart.Amounts",
                    "id": 2,
                    "rule": "optional"
                  },
                  "featureDetails": {
                    "type": "squareup.client.bills.Cart.FeatureDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "readOnlyCustomNote": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "returnLineItems": {
                    "type": "squareup.client.bills.Cart.ReturnLineItems",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "amountDetails": {
                    "type": "squareup.client.bills.Cart.AmountDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createdByUnitToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "returnType": {
                    "type": "squareup.client.bills.Cart.ReturnType",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "LineItems": {
                    "fields": {
                      "itemization": {
                        "type": "squareup.client.bills.Itemization",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "fee": {
                        "type": "squareup.client.bills.FeeLineItem",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "discount": {
                        "type": "squareup.client.bills.DiscountLineItem",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "roundingAdjustment": {
                        "type": "squareup.client.bills.RoundingAdjustmentLineItem",
                        "id": 4,
                        "rule": "optional"
                      },
                      "defaultDiningOption": {
                        "type": "squareup.client.bills.DiningOptionLineItem",
                        "id": 5,
                        "rule": "optional"
                      },
                      "compItemization": {
                        "type": "squareup.client.bills.Itemization",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "voidItemization": {
                        "type": "squareup.client.bills.Itemization",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "surcharge": {
                        "type": "squareup.client.bills.SurchargeLineItem",
                        "id": 8,
                        "rule": "repeated"
                      },
                      "itemizationGroups": {
                        "type": "squareup.client.bills.ItemizationGroup",
                        "id": 9,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Amounts": {
                    "fields": {
                      "totalMoney": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "taxMoney": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "discountMoney": {
                        "type": "squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "tipMoney": {
                        "type": "squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "surchargeMoney": {
                        "type": "squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "FeatureDetails": {
                    "fields": {
                      "orderDeprecated": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.Order",
                        "id": 1,
                        "rule": "optional"
                      },
                      "openTicket": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.OpenTicket",
                        "id": 2,
                        "rule": "optional"
                      },
                      "invoice": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.Invoice",
                        "id": 3,
                        "rule": "optional"
                      },
                      "kitchenPrinting": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.KitchenPrinting",
                        "id": 4,
                        "rule": "optional"
                      },
                      "buyerInfo": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.BuyerInfo",
                        "id": 5,
                        "rule": "optional"
                      },
                      "appointmentsDetails": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.AppointmentsDetails",
                        "id": 6,
                        "rule": "optional"
                      },
                      "availableInstrumentDetails": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.InstrumentDetails",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "coursingOptions": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.CoursingOptions",
                        "id": 8,
                        "rule": "optional"
                      },
                      "seating": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.Seating",
                        "id": 9,
                        "rule": "optional"
                      },
                      "billPrintState": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.BillPrintState",
                        "id": 10,
                        "rule": "optional"
                      },
                      "reopenDetails": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.ReopenDetails",
                        "id": 11,
                        "rule": "optional"
                      },
                      "coverCountChangeLog": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.CoverCountEvent",
                        "id": 12,
                        "rule": "repeated"
                      },
                      "authAndDelayedCapture": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.AuthAndDelayedCapture",
                        "id": 14,
                        "rule": "optional"
                      },
                      "rstOrderMetadata": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.RSTOrderMetadata",
                        "id": 15,
                        "rule": "optional"
                      },
                      "lifecycleEvent": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.LifecycleEvent",
                        "id": 16,
                        "rule": "repeated"
                      },
                      "orderDetails": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails",
                        "id": 17,
                        "rule": "optional"
                      },
                      "pricingEngineState": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.PricingEngineState",
                        "id": 18,
                        "rule": "optional"
                      },
                      "buyerNotificationDetails": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.BuyerNotificationDetails",
                        "id": 19,
                        "rule": "optional"
                      },
                      "channels": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.Channel",
                        "id": 20,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Order": {
                        "fields": {
                          "noteDeprecated": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "OpenTicket": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "note": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "ticketIdPair": {
                            "type": "squareup.client.IdPair",
                            "id": 3,
                            "rule": "optional"
                          },
                          "ticketOwner": {
                            "type": "squareup.client.CreatorDetails",
                            "id": 4,
                            "rule": "optional"
                          },
                          "predefinedTicket": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.OpenTicket.PredefinedTicket",
                            "id": 5,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "squareup.client.ISO8601Date",
                            "id": 7,
                            "rule": "optional"
                          },
                          "productsOpenedOn": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.OpenTicket.OpenTicketProductAssociation",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "createdByFirstTableTouch": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "reservationInformation": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation",
                            "id": 10,
                            "rule": "optional"
                          },
                          "vectorClockVersion": {
                            "type": "int64",
                            "id": 11,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "PredefinedTicket": {
                            "fields": {
                              "ticketGroup": {
                                "type": "squareup.api.items.TicketGroup",
                                "id": 1,
                                "rule": "optional"
                              },
                              "ticketTemplate": {
                                "type": "squareup.api.items.TicketTemplate",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "OpenTicketProductAssociation": {
                            "values": {
                              "DO_NOT_SET": 0,
                              "RESTAURANT_POS": 1,
                              "RETAIL_POS": 2,
                              "SQUARE_POS": 3,
                              "APPOINTMENTS_POS": 4
                            }
                          },
                          "ReservationInformation": {
                            "fields": {
                              "guestFirstName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "guestLastName": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "partySize": {
                                "type": "uint32",
                                "id": 3,
                                "rule": "optional"
                              },
                              "occasions": {
                                "type": "string",
                                "id": 4,
                                "rule": "repeated"
                              },
                              "guestRelationships": {
                                "type": "string",
                                "id": 5,
                                "rule": "repeated"
                              },
                              "providerName": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              },
                              "guestDiningPreferences": {
                                "type": "string",
                                "id": 7,
                                "rule": "repeated"
                              },
                              "guestSeatingPreferences": {
                                "type": "string",
                                "id": 8,
                                "rule": "repeated"
                              },
                              "reservationNotes": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes",
                                "id": 9,
                                "rule": "optional"
                              },
                              "reservationTime": {
                                "type": "string",
                                "id": 10,
                                "rule": "optional"
                              },
                              "reservationId": {
                                "type": "string",
                                "id": 11,
                                "rule": "optional"
                              },
                              "tags": {
                                "type": "string",
                                "id": 12,
                                "rule": "repeated"
                              },
                              "deposit": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit",
                                "id": 13,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "ReservationNotes": {
                                "fields": {
                                  "guestGeneralNote": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "guestDiningPreferencesNote": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "guestSpecialRelationshipNote": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "venueNote": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "guestRequest": {
                                    "type": "string",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "guestSeatingPreferencesNote": {
                                    "type": "string",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "Deposit": {
                                "fields": {
                                  "depositAmount": {
                                    "type": "squareup.common.Money",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "paymentId": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "Invoice": {
                        "fields": {
                          "invoiceIdPair": {
                            "type": "squareup.client.IdPair",
                            "id": 1,
                            "rule": "optional"
                          },
                          "tippingEnabled": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "version": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "isFinalPayment": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "associatedOrder": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.Invoice.AssociatedOrder",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "AssociatedOrder": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "version": {
                                "type": "int32",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "KitchenPrinting": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "InstrumentDetails": {
                        "fields": {
                          "instrumentToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "displayDetails": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.InstrumentDetails.DisplayDetails",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "DisplayDetails": {
                            "fields": {
                              "cardholderName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "lastFour": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "brand": {
                                "type": "squareup.client.bills.CardTender.Card.Brand",
                                "id": 3,
                                "rule": "optional"
                              },
                              "expiry": {
                                "type": "squareup.client.bills.CardData.KeyedCard.Expiry",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "BuyerInfo": {
                        "fields": {
                          "customerId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "displayDetails": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.BuyerInfo.DisplayDetails",
                            "id": 2,
                            "rule": "optional"
                          },
                          "availableInstrumentDetails": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.InstrumentDetails",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "customerGroups": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "DisplayDetails": {
                            "fields": {
                              "displayName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "lastVisit": {
                                "type": "squareup.client.ISO8601Date",
                                "id": 2,
                                "rule": "optional"
                              },
                              "email": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "phoneNumber": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "phoneToken": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "loyaltyAccountPhoneToken": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "AppointmentsDetails": {
                        "fields": {
                          "appointmentId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "appointmentStaff": {
                            "type": "squareup.client.CreatorDetails",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SourceTicketInformation": {
                        "fields": {
                          "clientId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CoursingOptions": {
                        "fields": {
                          "course": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.CoursingOptions.Course",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "Course": {
                            "fields": {
                              "courseIdPair": {
                                "type": "squareup.client.IdPair",
                                "id": 1,
                                "rule": "optional"
                              },
                              "ordinal": {
                                "type": "uint32",
                                "id": 2,
                                "rule": "optional"
                              },
                              "straightFire": {
                                "type": "bool",
                                "id": 3,
                                "rule": "optional"
                              },
                              "event": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.CoursingOptions.Course.Event",
                                "id": 4,
                                "rule": "repeated"
                              },
                              "sourceTicketInformation": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.SourceTicketInformation",
                                "id": 5,
                                "rule": "optional"
                              },
                              "name": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Event": {
                                "fields": {
                                  "eventIdPair": {
                                    "type": "squareup.client.IdPair",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "eventType": {
                                    "type": "squareup.client.bills.Cart.FeatureDetails.CoursingOptions.Course.Event.EventType",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "createdAt": {
                                    "type": "squareup.client.ISO8601Date",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "creatorDetails": {
                                    "type": "squareup.client.CreatorDetails",
                                    "id": 4,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "EventType": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "CREATION": 1,
                                      "SEND": 2,
                                      "ADDITION": 3,
                                      "FIRE": 4
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "Seating": {
                        "fields": {
                          "seat": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.Seating.Seat",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "coverCountChangeLog": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.CoverCountEvent",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "readOnlyCoverCount": {
                            "type": "uint32",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Seat": {
                            "fields": {
                              "seatIdPair": {
                                "type": "squareup.client.IdPair",
                                "id": 1,
                                "rule": "optional"
                              },
                              "ordinal": {
                                "type": "uint32",
                                "id": 2,
                                "rule": "optional"
                              },
                              "enabled": {
                                "type": "bool",
                                "id": 3,
                                "rule": "optional"
                              },
                              "createdAt": {
                                "type": "squareup.client.ISO8601Date",
                                "id": 4,
                                "rule": "optional"
                              },
                              "sourceOpenTicketClientId": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "sourceOpenTicketName": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              },
                              "sourceTicketInformation": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.SourceTicketInformation",
                                "id": 7,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "BillPrintState": {
                        "fields": {
                          "writeOnlyClientPrintedAt": {
                            "type": "squareup.client.ISO8601Date",
                            "id": 1,
                            "rule": "optional"
                          },
                          "writeOnlyPrinted": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "readOnlyPrinted": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "printedTotalMoney": {
                            "type": "squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "ReopenDetails": {
                        "fields": {
                          "reopenedAt": {
                            "type": "squareup.client.ISO8601Date",
                            "id": 1,
                            "rule": "optional"
                          },
                          "tenderDisplayDetails": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "TenderDisplayDetails": {
                            "fields": {
                              "type": {
                                "type": "squareup.client.bills.Tender.Type",
                                "id": 1,
                                "rule": "optional"
                              },
                              "totalMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "instrumentDetails": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.InstrumentDetails.DisplayDetails",
                                "id": 3,
                                "rule": "optional"
                              },
                              "tenderIdPair": {
                                "type": "squareup.client.IdPair",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "CoverCountEvent": {
                        "fields": {
                          "eventId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "eventType": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.CoverCountEvent.EventType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "count": {
                            "type": "uint32",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": 0
                            }
                          },
                          "isConfirmed": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "creatorDetails": {
                            "type": "squareup.client.CreatorDetails",
                            "id": 5,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "squareup.client.ISO8601Date",
                            "id": 6,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "uint32",
                            "id": 7,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "EventType": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "USER_SELECTED": 1,
                              "SPLIT": 2,
                              "MERGE": 3,
                              "VOID": 4
                            }
                          }
                        }
                      },
                      "AuthAndDelayedCapture": {
                        "fields": {
                          "billServerId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "RSTOrderMetadata": {
                        "fields": {
                          "orderName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "fulfillments": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.RSTOrderMetadata.Fulfillment",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "Fulfillment": {
                            "fields": {
                              "fulfillmentId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "fulfillmentTypeDisplayName": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "fulfillmentEntry": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.RSTOrderMetadata.Fulfillment.FulfillmentEntry",
                                "id": 3,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "FulfillmentEntry": {
                                "fields": {
                                  "fulfillmentEntryId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "itemizationIdPair": {
                                    "type": "squareup.client.IdPair",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "quantity": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "LifecycleEvent": {
                        "fields": {
                          "eventIdPair": {
                            "type": "squareup.client.IdPair",
                            "id": 1,
                            "rule": "optional"
                          },
                          "eventType": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.LifecycleEvent.EventType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "squareup.client.ISO8601Date",
                            "id": 3,
                            "rule": "optional"
                          },
                          "creatorDetails": {
                            "type": "squareup.client.CreatorDetails",
                            "id": 4,
                            "rule": "optional"
                          },
                          "ownershipTransferDetails": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "EventType": {
                            "values": {
                              "UNKNOWN": 0,
                              "CLOSE": 1,
                              "REOPEN": 2,
                              "OWNERSHIP_TRANSFER": 3,
                              "OPEN": 4
                            }
                          },
                          "OwnershipTransferDetails": {
                            "fields": {
                              "transferFromEmployee": {
                                "type": "squareup.client.Employee",
                                "id": 1,
                                "rule": "optional"
                              },
                              "transferToEmployee": {
                                "type": "squareup.client.Employee",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "OrderDetails": {
                        "fields": {
                          "orderId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "fulfillmentCreationDetails": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "FulfillmentCreationDetails": {
                            "fields": {
                              "recipient": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentRecipient",
                                "id": 1,
                                "rule": "optional"
                              },
                              "items": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentItems",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "type": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentType",
                                "id": 3,
                                "rule": "optional"
                              },
                              "state": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentState",
                                "id": 4,
                                "rule": "optional"
                              },
                              "locationId": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "note": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              },
                              "pickupDetails": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails",
                                "id": 7,
                                "rule": "optional"
                              },
                              "deliveryDetails": {
                                "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentDeliveryDetails",
                                "id": 8,
                                "rule": "optional"
                              },
                              "statusTrackingEnabled": {
                                "type": "bool",
                                "id": 9,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "FulfillmentPickupDetails": {
                                "fields": {
                                  "pickupAt": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "isCurbsidePickup": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "curbsidePickupDetails": {
                                    "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails.CurbsidePickupDetails",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "scheduleType": {
                                    "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails.ScheduleType",
                                    "id": 4,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "CurbsidePickupDetails": {
                                    "fields": {
                                      "curbsideDetails": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "ScheduleType": {
                                    "values": {
                                      "SCHEDULE_TYPE_DO_NOT_USE": 0,
                                      "SCHEDULED": 1,
                                      "ASAP": 2
                                    }
                                  }
                                }
                              },
                              "FulfillmentDeliveryDetails": {
                                "fields": {
                                  "deliverAt": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "scheduleType": {
                                    "type": "squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentDeliveryDetails.ScheduleType",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "ScheduleType": {
                                    "values": {
                                      "SCHEDULE_TYPE_DO_NOT_USE": 0,
                                      "SCHEDULED": 1,
                                      "ASAP": 2
                                    }
                                  }
                                }
                              },
                              "FulfillmentRecipient": {
                                "fields": {
                                  "customerId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "displayName": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "emailAddress": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "phoneNumber": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "address": {
                                    "type": "squareup.connect.v2.resources.Address",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "identifier": {
                                    "type": "string",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "FulfillmentItems": {
                                "fields": {
                                  "lineItemClientId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "quantity": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "FulfillmentType": {
                                "values": {
                                  "FULFILLMENT_TYPE_DO_NOT_USE": 0,
                                  "SHIPMENT": 1,
                                  "PICKUP": 2,
                                  "SIMPLE": 3,
                                  "DELIVERY": 4,
                                  "IN_STORE": 5
                                }
                              },
                              "FulfillmentState": {
                                "values": {
                                  "FULFILLMENT_STATE_DO_NOT_USE": 0,
                                  "NEW": 1,
                                  "COMPLETED": 2,
                                  "RESERVED": 3,
                                  "PREPARED": 4,
                                  "CANCELED": 5,
                                  "FAILED": 6
                                }
                              }
                            }
                          }
                        }
                      },
                      "PricingEngineState": {
                        "fields": {
                          "blacklistedDiscountIds": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "blocklistedTaxIds": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "blocklistedSurchargeIds": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "BuyerNotificationDetails": {
                        "fields": {
                          "phoneNumber": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Channel": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "type": {
                            "type": "squareup.client.bills.Cart.FeatureDetails.Channel.Type",
                            "id": 2,
                            "rule": "optional"
                          },
                          "uid": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "CHANNEL_TYPE_DO_NOT_USE": 0,
                              "MARKETING": 1,
                              "SALES": 2
                            }
                          }
                        }
                      }
                    }
                  },
                  "ReturnLineItems": {
                    "fields": {
                      "sourceBillServerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "returnItemization": {
                        "type": "squareup.client.bills.Cart.ReturnLineItems.ReturnItemization",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "discountLineItem": {
                        "type": "squareup.client.bills.DiscountLineItem",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "feeLineItem": {
                        "type": "squareup.client.bills.FeeLineItem",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "roundingAdjustment": {
                        "type": "squareup.client.bills.RoundingAdjustmentLineItem",
                        "id": 5,
                        "rule": "optional"
                      },
                      "returnTipLineItem": {
                        "type": "squareup.client.bills.ReturnTipLineItem",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "returnSurchargeLineItem": {
                        "type": "squareup.client.bills.ReturnSurchargeLineItem",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "itemizationGroups": {
                        "type": "squareup.client.bills.ItemizationGroup",
                        "id": 8,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ReturnItemization": {
                        "fields": {
                          "sourceItemizationIdPair": {
                            "type": "squareup.client.IdPair",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemization": {
                            "type": "squareup.client.bills.Itemization",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "AmountDetails": {
                    "fields": {
                      "return": {
                        "type": "squareup.client.bills.Cart.Amounts",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sale": {
                        "type": "squareup.client.bills.Cart.Amounts",
                        "id": 2,
                        "rule": "optional"
                      },
                      "net": {
                        "type": "squareup.client.bills.Cart.Amounts",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ReturnType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "LINKED": 1,
                      "UNLINKED": 2
                    }
                  }
                }
              },
              "Itemization": {
                "fields": {
                  "itemizationIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "measurementUnit": {
                    "type": "squareup.omg.model.Order.QuantityUnit",
                    "id": 14,
                    "rule": "optional"
                  },
                  "quantityEntryType": {
                    "type": "squareup.client.bills.Itemization.QuantityEntryType",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": "MANUALLY_ENTERED"
                    }
                  },
                  "tareQuantity": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "customNote": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "readOnlyAppliedItemizationGroups": {
                    "type": "string",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "configuration": {
                    "type": "squareup.client.bills.Itemization.Configuration",
                    "id": 5,
                    "rule": "optional"
                  },
                  "writeOnlyBackingDetails": {
                    "type": "squareup.client.bills.Itemization.BackingDetails",
                    "id": 6,
                    "rule": "optional"
                  },
                  "readOnlyDisplayDetails": {
                    "type": "squareup.client.bills.Itemization.DisplayDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": "squareup.client.bills.Itemization.Amounts",
                    "id": 8,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.client.ISO8601Date",
                    "id": 9,
                    "rule": "optional"
                  },
                  "writeOnlyDeleted": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "event": {
                    "type": "squareup.client.bills.Itemization.Event",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "featureDetails": {
                    "type": "squareup.client.bills.Itemization.FeatureDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "employeeAttributions": {
                    "type": "squareup.client.bills.Itemization.EmployeeAttribution",
                    "id": 15,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "QuantityEntryType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "MANUALLY_ENTERED": 1,
                      "READ_FROM_SCALE": 2,
                      "MANUAL_WITH_CONNECTED_SCALE": 3,
                      "READ_FROM_SCALE_TARED": 4,
                      "READ_FROM_SCALE_WITH_MANUAL_TARE": 5
                    }
                  },
                  "Configuration": {
                    "fields": {
                      "selectedOptions": {
                        "type": "squareup.client.bills.Itemization.Configuration.SelectedOptions",
                        "id": 1,
                        "rule": "optional"
                      },
                      "backingType": {
                        "type": "squareup.client.bills.Itemization.Configuration.BackingType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "itemVariationPriceMoney": {
                        "type": "squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "category": {
                        "type": "squareup.api.items.MenuCategory",
                        "id": 4,
                        "rule": "optional"
                      },
                      "taxCategory": {
                        "type": "squareup.connect.v2.common.TaxCategory",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": "GENERAL_TANGIBLE_GOOD"
                        }
                      }
                    },
                    "nested": {
                      "SelectedOptions": {
                        "fields": {
                          "itemVariationDeprecated": {
                            "type": "squareup.api.items.ItemVariation",
                            "id": 1,
                            "rule": "optional"
                          },
                          "modifierOption": {
                            "type": "squareup.client.bills.ModifierOptionLineItem",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "discount": {
                            "type": "squareup.client.bills.DiscountLineItem",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "fee": {
                            "type": "squareup.client.bills.FeeLineItem",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "itemVariationDetails": {
                            "type": "squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails",
                            "id": 5,
                            "rule": "optional"
                          },
                          "diningOption": {
                            "type": "squareup.client.bills.DiningOptionLineItem",
                            "id": 6,
                            "rule": "optional"
                          },
                          "surcharge": {
                            "type": "squareup.client.bills.SurchargeLineItem",
                            "id": 7,
                            "rule": "repeated"
                          },
                          "group": {
                            "type": "squareup.client.bills.GroupLineItem",
                            "id": 8,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "ItemVariationDetails": {
                            "fields": {
                              "readOnlyDisplayDetails": {
                                "type": "squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails",
                                "id": 1,
                                "rule": "optional"
                              },
                              "writeOnlyBackingDetails": {
                                "type": "squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails",
                                "id": 2,
                                "rule": "optional"
                              },
                              "giftCardDetails": {
                                "type": "squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails",
                                "id": 3,
                                "rule": "optional"
                              },
                              "displayVariationName": {
                                "type": "bool",
                                "id": 4,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "DisplayDetails": {
                                "fields": {
                                  "name": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "priceMoney": {
                                    "type": "squareup.common.Money",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "cogsObjectId": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "sku": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "BackingDetails": {
                                "fields": {
                                  "itemVariation": {
                                    "type": "squareup.api.items.ItemVariation",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "measurementUnit": {
                                    "type": "squareup.omg.model.Order.QuantityUnit",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "GiftCardDetails": {
                                "fields": {
                                  "giftCardServerId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "activityType": {
                                    "type": "squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails.ActivityType",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "panSuffix": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "ActivityType": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "ACTIVATION": 1,
                                      "RELOAD": 2,
                                      "UNACTIVATED_SALE": 3
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "BackingType": {
                        "values": {
                          "UNKNOWN": 0,
                          "CUSTOM_AMOUNT": 1,
                          "ITEM_VARIATION": 2,
                          "CUSTOM_ITEM_VARIATION": 3
                        }
                      }
                    }
                  },
                  "BackingDetails": {
                    "fields": {
                      "item": {
                        "type": "squareup.api.items.Item",
                        "id": 1,
                        "rule": "optional"
                      },
                      "itemImage": {
                        "type": "squareup.api.items.ItemImage",
                        "id": 2,
                        "rule": "optional"
                      },
                      "category": {
                        "type": "squareup.api.items.MenuCategory",
                        "id": 3,
                        "rule": "optional"
                      },
                      "availableOptions": {
                        "type": "squareup.client.bills.Itemization.BackingDetails.AvailableOptions",
                        "id": 4,
                        "rule": "optional"
                      },
                      "menu": {
                        "type": "squareup.api.items.Menu",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AvailableOptions": {
                        "fields": {
                          "itemVariation": {
                            "type": "squareup.api.items.ItemVariation",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "modifierList": {
                            "type": "squareup.client.bills.Itemization.BackingDetails.AvailableOptions.ModifierList",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "ModifierList": {
                            "fields": {
                              "modifierList": {
                                "type": "squareup.api.items.ItemModifierList",
                                "id": 1,
                                "rule": "optional"
                              },
                              "modifierOption": {
                                "type": "squareup.api.items.ItemModifierOption",
                                "id": 2,
                                "rule": "repeated"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "DisplayDetails": {
                    "fields": {
                      "item": {
                        "type": "squareup.client.bills.Itemization.DisplayDetails.Item",
                        "id": 2,
                        "rule": "optional"
                      },
                      "menuCategory": {
                        "type": "squareup.client.bills.Itemization.DisplayDetails.MenuCategory",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Item": {
                        "fields": {
                          "color": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "abbreviation": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "imageUrl": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "cogsObjectId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "MenuCategory": {
                        "fields": {
                          "cogsObjectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "Amounts": {
                    "fields": {
                      "itemVariationPriceMoney": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "itemVariationPriceTimesQuantityMoney": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "discountMoney": {
                        "type": "squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "taxMoney": {
                        "type": "squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "totalMoney": {
                        "type": "squareup.common.Money",
                        "id": 7,
                        "rule": "optional"
                      },
                      "grossSalesMoney": {
                        "type": "squareup.common.Money",
                        "id": 8,
                        "rule": "optional"
                      },
                      "taxableAmount": {
                        "type": "squareup.common.Money",
                        "id": 9,
                        "rule": "optional"
                      },
                      "surchargeMoney": {
                        "type": "squareup.common.Money",
                        "id": 10,
                        "rule": "optional"
                      },
                      "comboPriceAdjustmentMoney": {
                        "type": "squareup.common.Money",
                        "id": 11,
                        "rule": "optional"
                      },
                      "comboAppliedMoney": {
                        "type": "squareup.common.Money",
                        "id": 12,
                        "rule": "optional"
                      },
                      "comboAppliedWeight": {
                        "type": "int64",
                        "id": 13,
                        "rule": "optional"
                      }
                    }
                  },
                  "Event": {
                    "fields": {
                      "eventIdPair": {
                        "type": "squareup.client.IdPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "eventType": {
                        "type": "squareup.client.bills.Itemization.Event.EventType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "squareup.client.ISO8601Date",
                        "id": 3,
                        "rule": "optional"
                      },
                      "creatorDetails": {
                        "type": "squareup.client.CreatorDetails",
                        "id": 4,
                        "rule": "optional"
                      },
                      "reason": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "splitEventDetails": {
                        "type": "squareup.client.bills.Itemization.Event.SplitEventDetails",
                        "id": 6,
                        "rule": "optional"
                      },
                      "kdsEventDetails": {
                        "type": "squareup.client.bills.Itemization.Event.KdsEventDetails",
                        "id": 7,
                        "rule": "optional"
                      },
                      "originalItemization": {
                        "type": "squareup.client.bills.Itemization.Event.ItemizationReference",
                        "id": 8,
                        "rule": "optional"
                      },
                      "childItemizationTokenPairs": {
                        "type": "squareup.client.IdPair",
                        "id": 9,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "EventType": {
                        "values": {
                          "UNKNOWN": 0,
                          "CREATION": 1,
                          "COMP": 2,
                          "VOID": 3,
                          "UNCOMP": 4,
                          "DELETE": 5,
                          "SPLIT": 6,
                          "FIRE": 7,
                          "KDS_COMPLETE": 8,
                          "KDS_UNCOMPLETE": 9,
                          "SEND": 10,
                          "DISCOUNT": 11,
                          "REMOVE_DISCOUNT": 12,
                          "PRINT": 13,
                          "MOVE": 14,
                          "AMENDED_REOPEN": 15,
                          "REFUNDED_REOPEN": 16,
                          "SPLIT_ITEM_PAYMENT": 17,
                          "UNSPLIT_ITEM_PAYMENT": 18
                        }
                      },
                      "SplitEventDetails": {
                        "fields": {
                          "childItemization": {
                            "type": "squareup.client.bills.Itemization.Event.SplitEventDetails.ChildItemization",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "ChildItemization": {
                            "fields": {
                              "ticketIdPair": {
                                "type": "squareup.client.IdPair",
                                "id": 1,
                                "rule": "optional"
                              },
                              "childItemizationIdPair": {
                                "type": "squareup.client.IdPair",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "KdsEventDetails": {
                        "fields": {
                          "kds": {
                            "type": "squareup.client.kds.models.KdsStation",
                            "id": 1,
                            "rule": "optional"
                          },
                          "sharedId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ItemizationReference": {
                        "fields": {
                          "ticketTokenPair": {
                            "type": "squareup.client.IdPair",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemizationTokenPair": {
                            "type": "squareup.client.IdPair",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "FeatureDetails": {
                    "fields": {
                      "kitchenDisplay": {
                        "type": "squareup.client.bills.Itemization.FeatureDetails.KitchenDisplay",
                        "id": 1,
                        "rule": "optional"
                      },
                      "courseIdPair": {
                        "type": "squareup.client.IdPair",
                        "id": 2,
                        "rule": "optional"
                      },
                      "seating": {
                        "type": "squareup.client.bills.Itemization.FeatureDetails.Seating",
                        "id": 3,
                        "rule": "optional"
                      },
                      "appointmentsServiceDetails": {
                        "type": "squareup.client.bills.Itemization.FeatureDetails.AppointmentsServiceDetails",
                        "id": 4,
                        "rule": "optional"
                      },
                      "inheritedItemizationDetails": {
                        "type": "squareup.client.bills.Itemization.FeatureDetails.InheritedItemizationDetails",
                        "id": 5,
                        "rule": "optional"
                      },
                      "pricingEngineState": {
                        "type": "squareup.client.bills.Itemization.FeatureDetails.PricingEngineState",
                        "id": 6,
                        "rule": "optional"
                      },
                      "deviceCredentialToken": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "signInType": {
                        "type": "squareup.client.bills.Itemization.FeatureDetails.SignInType",
                        "id": 8,
                        "rule": "optional"
                      },
                      "channels": {
                        "type": "squareup.client.bills.Cart.FeatureDetails.Channel",
                        "id": 9,
                        "rule": "repeated"
                      },
                      "splitDetails": {
                        "type": "squareup.client.bills.Itemization.FeatureDetails.LineItemSplitDetails",
                        "id": 10,
                        "rule": "optional"
                      },
                      "deviceId": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "KitchenDisplay": {
                        "fields": {
                          "prepComplete": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "expediteComplete": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Seating": {
                        "fields": {
                          "destination": {
                            "type": "squareup.client.bills.Itemization.FeatureDetails.Seating.Destination",
                            "id": 1,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Destination": {
                            "fields": {
                              "type": {
                                "type": "squareup.client.bills.Itemization.FeatureDetails.Seating.Destination.Type",
                                "id": 1,
                                "rule": "optional"
                              },
                              "seatIdPair": {
                                "type": "squareup.client.IdPair",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "createdAt": {
                                "type": "squareup.client.ISO8601Date",
                                "id": 3,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Type": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "TABLE_SHARE": 1,
                                  "SEAT": 2
                                }
                              }
                            }
                          }
                        }
                      },
                      "AppointmentsServiceDetails": {
                        "fields": {
                          "serviceId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "serviceDuration": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "ordinal": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "transitionTimeDuration": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          },
                          "pricingType": {
                            "type": "squareup.api.items.PricingType",
                            "id": 5,
                            "rule": "optional"
                          },
                          "noShowFeeMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "intermissions": {
                            "type": "squareup.api.items.Intermission",
                            "id": 7,
                            "rule": "repeated"
                          },
                          "resourceTokens": {
                            "type": "string",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "resources": {
                            "type": "squareup.client.bills.Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails",
                            "id": 9,
                            "rule": "repeated"
                          },
                          "anyAvailableEmployee": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ResourceDetails": {
                            "fields": {
                              "resourceToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "name": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "InheritedItemizationDetails": {
                        "fields": {
                          "inheritedEventIdPairs": {
                            "type": "squareup.client.IdPair",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "createReason": {
                            "type": "squareup.client.bills.Itemization.FeatureDetails.InheritedItemizationDetails.CreateReason",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CreateReason": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "REOPEN": 1
                            }
                          }
                        }
                      },
                      "PricingEngineState": {
                        "fields": {
                          "blacklistedDiscountIds": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "blocklistedTaxIds": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SignInType": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "DEVICE_CODE": 1,
                          "USERNAME_PASSWORD": 2
                        }
                      },
                      "LineItemSplitDetails": {
                        "fields": {
                          "splitId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "splitPartNumber": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "splitTotalParts": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "originalLineItemPricing": {
                            "type": "squareup.client.bills.Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "LineItemPricing": {
                            "fields": {
                              "basePriceMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "grossSalesMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "originalQuantity": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "originalModifierBasePrices": {
                                "type": "squareup.common.Money",
                                "id": 4,
                                "keyType": "string"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "EmployeeAttribution": {
                    "fields": {
                      "employee": {
                        "type": "squareup.client.Employee",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ApplicationScope": {
                "values": {
                  "UNKNOWN": 0,
                  "ITEMIZATION_LEVEL": 1,
                  "CART_LEVEL": 2,
                  "CART_LEVEL_FIXED": 3,
                  "ITEMIZATION_LEVEL_PER_QUANTITY": 4
                }
              },
              "DiscountLineItem": {
                "fields": {
                  "discountLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.client.ISO8601Date",
                    "id": 7,
                    "rule": "optional"
                  },
                  "configuration": {
                    "type": "squareup.client.bills.DiscountLineItem.Configuration",
                    "id": 6,
                    "rule": "optional"
                  },
                  "writeOnlyBackingDetails": {
                    "type": "squareup.client.bills.DiscountLineItem.BackingDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyDisplayDetails": {
                    "type": "squareup.client.bills.DiscountLineItem.DisplayDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": "squareup.client.bills.DiscountLineItem.Amounts",
                    "id": 4,
                    "rule": "optional"
                  },
                  "writeOnlyDeleted": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "applicationScope": {
                    "type": "squareup.client.bills.ApplicationScope",
                    "id": 8,
                    "rule": "optional"
                  },
                  "applicationMethod": {
                    "type": "squareup.client.bills.DiscountLineItem.ApplicationMethod",
                    "id": 9,
                    "rule": "optional"
                  },
                  "discountQuantity": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Configuration": {
                    "fields": {
                      "variablePercentage": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "variableAmountMoney": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "BackingDetails": {
                    "fields": {
                      "discount": {
                        "type": "squareup.api.items.Discount",
                        "id": 1,
                        "rule": "optional"
                      },
                      "couponId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "backingType": {
                        "type": "squareup.client.bills.DiscountLineItem.BackingDetails.BackingType",
                        "id": 3,
                        "rule": "optional"
                      },
                      "couponIds": {
                        "type": "string",
                        "id": 4,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "BackingType": {
                        "values": {
                          "ITEMS_SERVICE_DISCOUNT": 0,
                          "CUSTOM_DISCOUNT": 1
                        }
                      }
                    }
                  },
                  "DisplayDetails": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "percentage": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cogsObjectId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "applicationMethod": {
                        "type": "squareup.api.items.Discount.ApplicationMethod",
                        "id": 4,
                        "rule": "optional"
                      },
                      "couponIds": {
                        "type": "string",
                        "id": 5,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Amounts": {
                    "fields": {
                      "appliedMoney": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ApplicationMethod": {
                    "values": {
                      "UNKNOWN": 0,
                      "MANUAL": 1,
                      "PRICING_RULE": 2
                    }
                  }
                }
              },
              "FeeLineItem": {
                "fields": {
                  "feeLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.client.ISO8601Date",
                    "id": 7,
                    "rule": "optional"
                  },
                  "writeOnlyBackingDetails": {
                    "type": "squareup.client.bills.FeeLineItem.BackingDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyDisplayDetails": {
                    "type": "squareup.client.bills.FeeLineItem.DisplayDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": "squareup.client.bills.FeeLineItem.Amounts",
                    "id": 4,
                    "rule": "optional"
                  },
                  "readOnlyTranslatedName": {
                    "type": "squareup.client.bills.TranslatedName",
                    "id": 5,
                    "rule": "optional"
                  },
                  "writeOnlyDeleted": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "applicationMethod": {
                    "type": "squareup.client.bills.FeeLineItem.ApplicationMethod",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BackingDetails": {
                    "fields": {
                      "fee": {
                        "type": "squareup.api.items.Fee",
                        "id": 1,
                        "rule": "optional"
                      },
                      "backingType": {
                        "type": "squareup.client.bills.FeeLineItem.BackingDetails.BackingType",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "BackingType": {
                        "values": {
                          "ITEMS_SERVICE_FEE": 0,
                          "CUSTOM_FEE": 1
                        }
                      }
                    }
                  },
                  "DisplayDetails": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "percentage": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "calculationPhase": {
                        "type": "squareup.api.items.CalculationPhase",
                        "id": 3,
                        "rule": "optional"
                      },
                      "inclusionType": {
                        "type": "squareup.api.items.Fee.InclusionType",
                        "id": 4,
                        "rule": "optional"
                      },
                      "taxTypeName": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "taxTypeNumber": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "taxTypeId": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "cogsObjectId": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "taxLabelOrder": {
                        "type": "int32",
                        "id": 9,
                        "rule": "optional"
                      },
                      "amountMoney": {
                        "type": "squareup.common.Money",
                        "id": 10,
                        "rule": "optional"
                      }
                    }
                  },
                  "Amounts": {
                    "fields": {
                      "appliedMoney": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "appliedToMoney": {
                        "type": "squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "afterApplicationTotalMoney": {
                        "type": "squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "ApplicationMethod": {
                    "values": {
                      "UNKNOWN": 0,
                      "MANUAL": 1,
                      "AUTOMATIC": 2
                    }
                  }
                }
              },
              "ModifierOptionLineItem": {
                "fields": {
                  "modifierOptionLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": "squareup.client.bills.ModifierOptionLineItem.Amounts",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyDisplayDetails": {
                    "type": "squareup.client.bills.ModifierOptionLineItem.DisplayDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "writeOnlyBackingDetails": {
                    "type": "squareup.client.bills.ModifierOptionLineItem.BackingDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "hideFromCustomer": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "featureDetails": {
                    "type": "squareup.client.bills.ModifierOptionLineItem.FeatureDetails",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Amounts": {
                    "fields": {
                      "modifierOptionMoney": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "modifierOptionTimesQuantityMoney": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "DisplayDetails": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "sortOrder": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "cogsObjectId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "BackingDetails": {
                    "fields": {
                      "backingModifierOption": {
                        "type": "squareup.api.items.ItemModifierOption",
                        "id": 1,
                        "rule": "optional"
                      },
                      "modifierList": {
                        "type": "squareup.api.items.ItemModifierList",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "FeatureDetails": {
                    "fields": {
                      "conversationalMode": {
                        "type": "squareup.client.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "quantities": {
                        "type": "squareup.client.bills.ModifierOptionLineItem.FeatureDetails.Quantities",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ConversationalMode": {
                        "fields": {
                          "type": {
                            "type": "squareup.client.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode.Type",
                            "id": 1,
                            "rule": "optional"
                          },
                          "uid": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "UNKNOWN": 0,
                              "ADD": 1,
                              "EXTRA": 2,
                              "SIDE": 3,
                              "SUB": 4,
                              "NO": 5,
                              "ALLERGY": 6
                            }
                          }
                        }
                      },
                      "Quantities": {
                        "fields": {
                          "modifierQuantity": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "modifierQuantityTimesItemizationQuantity": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "RoundingAdjustmentLineItem": {
                "fields": {
                  "calculationPhase": {
                    "type": "squareup.api.items.CalculationPhase",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": "squareup.client.bills.RoundingAdjustmentLineItem.Amounts",
                    "id": 2,
                    "rule": "optional"
                  },
                  "roundingAdjustmentLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 3,
                    "rule": "optional"
                  },
                  "localizedName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Amounts": {
                    "fields": {
                      "appliedMoney": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "DiningOptionLineItem": {
                "fields": {
                  "diningOptionLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "backingDetails": {
                    "type": "squareup.client.bills.DiningOptionLineItem.BackingDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "applicationScope": {
                    "type": "squareup.client.bills.ApplicationScope",
                    "id": 3,
                    "rule": "optional"
                  },
                  "displayDetails": {
                    "type": "squareup.client.bills.DiningOptionLineItem.DisplayDetails",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BackingDetails": {
                    "fields": {
                      "diningOption": {
                        "type": "squareup.api.items.DiningOption",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "DisplayDetails": {
                    "fields": {
                      "cogsObjectId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "TipLineItem": {
                "fields": {
                  "tipLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": "squareup.client.bills.TipLineItem.Amounts",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tenderServerToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Amounts": {
                    "fields": {
                      "appliedMoney": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SurchargeLineItem": {
                "fields": {
                  "surchargeLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "backingDetails": {
                    "type": "squareup.client.bills.SurchargeLineItem.BackingDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amounts": {
                    "type": "squareup.client.bills.SurchargeLineItem.Amounts",
                    "id": 3,
                    "rule": "optional"
                  },
                  "writeOnlyDeleted": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "fee": {
                    "type": "squareup.client.bills.FeeLineItem",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "pricingEngineState": {
                    "type": "squareup.client.bills.SurchargeLineItem.PricingEngineState",
                    "id": 6,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": "1.0"
                    }
                  },
                  "createdAt": {
                    "type": "squareup.client.ISO8601Date",
                    "id": 8,
                    "rule": "optional"
                  },
                  "applicationScope": {
                    "type": "squareup.client.bills.ApplicationScope",
                    "id": 9,
                    "rule": "optional"
                  },
                  "applicationMethod": {
                    "type": "squareup.client.bills.SurchargeLineItem.ApplicationMethod",
                    "id": 10,
                    "rule": "optional"
                  },
                  "taxCategory": {
                    "type": "squareup.connect.v2.common.TaxCategory",
                    "id": 11,
                    "rule": "optional"
                  },
                  "disabled": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "topLevelSurchargeLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 13,
                    "rule": "optional"
                  },
                  "displayDetails": {
                    "type": "squareup.client.bills.SurchargeLineItem.DisplayDetails",
                    "id": 14,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BackingDetails": {
                    "fields": {
                      "surcharge": {
                        "type": "squareup.api.items.Surcharge",
                        "id": 1,
                        "rule": "optional"
                      },
                      "backingType": {
                        "type": "squareup.client.bills.SurchargeLineItem.BackingDetails.BackingType",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "ITEMS_SERVICE_SURCHARGE"
                        }
                      }
                    },
                    "nested": {
                      "BackingType": {
                        "values": {
                          "ITEMS_SERVICE_SURCHARGE": 0,
                          "CUSTOM_SURCHARGE": 1
                        }
                      }
                    }
                  },
                  "Amounts": {
                    "fields": {
                      "appliedMoney": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "PricingEngineState": {
                    "fields": {
                      "blocklistedTaxIds": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "ApplicationMethod": {
                    "values": {
                      "UNKNOWN": 0,
                      "MANUAL": 1,
                      "PRICING_RULE": 2
                    }
                  },
                  "DisplayDetails": {
                    "fields": {
                      "cogsObjectId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GroupLineItem": {
                "fields": {
                  "type": {
                    "type": "squareup.client.bills.ItemizationGroup.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "groupClientId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "configuration": {
                    "type": "squareup.client.bills.GroupLineItem.Configuration",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Configuration": {
                    "fields": {
                      "comboConfiguration": {
                        "type": "squareup.client.bills.GroupLineItem.Configuration.ComboConfiguration",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ComboConfiguration": {
                        "fields": {
                          "appliedComboClientId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "appliedComboChoiceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              },
              "ItemizationGroup": {
                "fields": {
                  "itemizationGroupIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemizationClientIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "type": {
                    "type": "squareup.client.bills.ItemizationGroup.Type",
                    "id": 3,
                    "rule": "optional"
                  },
                  "writeOnlyBackingDetails": {
                    "type": "squareup.client.bills.ItemizationGroup.BackingDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "readOnlyDisplayDetails": {
                    "type": "squareup.client.bills.ItemizationGroup.DisplayDetails",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DEFAULT_ITEMIZATION_GROUP_TYPE_DO_NOT_USE": 0,
                      "CUSTOM": 1,
                      "COMBO": 2
                    }
                  },
                  "BackingDetails": {
                    "fields": {
                      "item": {
                        "type": "squareup.api.items.Item",
                        "id": 1,
                        "rule": "optional"
                      },
                      "itemVariation": {
                        "type": "squareup.api.items.ItemVariation",
                        "id": 2,
                        "rule": "optional"
                      },
                      "merchantCatalogObjects": {
                        "type": "squareup.client.bills.ItemizationGroup.BackingDetails.MerchantCatalogObjects",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "MerchantCatalogObjects": {
                        "fields": {
                          "itemCatalogObject": {
                            "type": "squareup.items.merchant.CatalogObject",
                            "id": 1,
                            "rule": "optional"
                          },
                          "itemVariationCatalogObject": {
                            "type": "squareup.items.merchant.CatalogObject",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "DisplayDetails": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "variationName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "note": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "comboChoices": {
                        "type": "squareup.client.bills.ItemizationGroup.DisplayDetails.ComboChoice",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "itemVariationPriceMoney": {
                        "type": "squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "cogsObjectId": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ComboChoice": {
                        "fields": {
                          "comboChoiceId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "clientToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "validationDetails": {
                            "type": "squareup.client.bills.ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ValidationDetails": {
                            "fields": {
                              "item": {
                                "type": "squareup.api.items.Item",
                                "id": 1,
                                "rule": "optional"
                              },
                              "itemVariation": {
                                "type": "squareup.api.items.ItemVariation",
                                "id": 2,
                                "rule": "optional"
                              },
                              "category": {
                                "type": "squareup.api.items.MenuCategory",
                                "id": 3,
                                "rule": "optional"
                              },
                              "numSelections": {
                                "type": "int64",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              },
              "ReturnTipLineItem": {
                "fields": {
                  "sourceTipLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tipLineItem": {
                    "type": "squareup.client.bills.TipLineItem",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReturnSurchargeLineItem": {
                "fields": {
                  "sourceSurchargeLineItemIdPair": {
                    "type": "squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "surchargeLineItem": {
                    "type": "squareup.client.bills.SurchargeLineItem",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.LineItems && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Order && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.PredefinedTicket && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.OpenTicketProductAssociation && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.ReservationInformation && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.ReservationInformation?.nested?.ReservationNotes && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OpenTicket?.nested?.ReservationInformation?.nested?.Deposit && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Invoice && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Invoice?.nested?.AssociatedOrder && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.KitchenPrinting && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.InstrumentDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.InstrumentDetails?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.BuyerInfo && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.BuyerInfo?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.AppointmentsDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.SourceTicketInformation && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoursingOptions && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoursingOptions?.nested?.Course && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoursingOptions?.nested?.Course?.nested?.Event && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoursingOptions?.nested?.Course?.nested?.Event?.nested?.EventType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Seating && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Seating?.nested?.Seat && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.BillPrintState && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.ReopenDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.ReopenDetails?.nested?.TenderDisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoverCountEvent && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.CoverCountEvent?.nested?.EventType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.AuthAndDelayedCapture && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.RSTOrderMetadata && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.RSTOrderMetadata?.nested?.Fulfillment && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.RSTOrderMetadata?.nested?.Fulfillment?.nested?.FulfillmentEntry && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.LifecycleEvent && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.LifecycleEvent?.nested?.EventType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.LifecycleEvent?.nested?.OwnershipTransferDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentPickupDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentPickupDetails?.nested?.CurbsidePickupDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentPickupDetails?.nested?.ScheduleType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentDeliveryDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentDeliveryDetails?.nested?.ScheduleType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentRecipient && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentItems && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.OrderDetails?.nested?.FulfillmentCreationDetails?.nested?.FulfillmentState && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.PricingEngineState && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.BuyerNotificationDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Channel && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.FeatureDetails?.nested?.Channel?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.ReturnLineItems && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.ReturnLineItems?.nested?.ReturnItemization && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.AmountDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Cart?.nested?.ReturnType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.QuantityEntryType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Configuration && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.GiftCardDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.SelectedOptions?.nested?.ItemVariationDetails?.nested?.GiftCardDetails?.nested?.ActivityType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Configuration?.nested?.BackingType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.BackingDetails?.nested?.AvailableOptions && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.BackingDetails?.nested?.AvailableOptions?.nested?.ModifierList && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.DisplayDetails?.nested?.Item && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.DisplayDetails?.nested?.MenuCategory && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Event && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.EventType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.SplitEventDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.SplitEventDetails?.nested?.ChildItemization && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.KdsEventDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.Event?.nested?.ItemizationReference && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.KitchenDisplay && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.Seating && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.Seating?.nested?.Destination && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.Seating?.nested?.Destination?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.AppointmentsServiceDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.AppointmentsServiceDetails?.nested?.ResourceDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.InheritedItemizationDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.InheritedItemizationDetails?.nested?.CreateReason && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.PricingEngineState && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.SignInType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.LineItemSplitDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.FeatureDetails?.nested?.LineItemSplitDetails?.nested?.LineItemPricing && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Itemization?.nested?.EmployeeAttribution && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ApplicationScope && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiscountLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiscountLineItem?.nested?.Configuration && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiscountLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiscountLineItem?.nested?.BackingDetails?.nested?.BackingType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiscountLineItem?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiscountLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiscountLineItem?.nested?.ApplicationMethod && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.FeeLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.FeeLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.FeeLineItem?.nested?.BackingDetails?.nested?.BackingType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.FeeLineItem?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.FeeLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.FeeLineItem?.nested?.ApplicationMethod && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ModifierOptionLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.FeatureDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.FeatureDetails?.nested?.ConversationalMode && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.FeatureDetails?.nested?.ConversationalMode?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ModifierOptionLineItem?.nested?.FeatureDetails?.nested?.Quantities && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.RoundingAdjustmentLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.RoundingAdjustmentLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiningOptionLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiningOptionLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.DiningOptionLineItem?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.TipLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.TipLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SurchargeLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SurchargeLineItem?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SurchargeLineItem?.nested?.BackingDetails?.nested?.BackingType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SurchargeLineItem?.nested?.Amounts && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SurchargeLineItem?.nested?.PricingEngineState && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SurchargeLineItem?.nested?.ApplicationMethod && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SurchargeLineItem?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GroupLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GroupLineItem?.nested?.Configuration && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GroupLineItem?.nested?.Configuration?.nested?.ComboConfiguration && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ItemizationGroup && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ItemizationGroup?.nested?.Type && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ItemizationGroup?.nested?.BackingDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ItemizationGroup?.nested?.BackingDetails?.nested?.MerchantCatalogObjects && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ItemizationGroup?.nested?.DisplayDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ItemizationGroup?.nested?.DisplayDetails?.nested?.ComboChoice && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ItemizationGroup?.nested?.DisplayDetails?.nested?.ComboChoice?.nested?.ValidationDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ReturnTipLineItem && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ReturnSurchargeLineItem) {
  $root.addJSON(jsonData);
}

/**
 * Container for all line items on a bill.
 *
 * The cart should contain all information necessary to provide accurate reporting.
 *
 * SOURCE Cart @ squareup/client/bills/cart.proto at 34:1
 */
export const Cart = $root.lookupType('squareup.client.bills.Cart');
fixType(Cart);
Builder.createAndAttachToType(Cart);
/**
 * Items sold by this bill.
 *
 * SOURCE LineItems @ squareup/client/bills/cart.proto at 36:3
 */
Cart.LineItems = $root.lookupType('squareup.client.bills.Cart.LineItems');
fixType(Cart.LineItems);
Builder.createAndAttachToType(Cart.LineItems);
/**
 * SOURCE Amounts @ squareup/client/bills/cart.proto at 106:3
 */
Cart.Amounts = $root.lookupType('squareup.client.bills.Cart.Amounts');
fixType(Cart.Amounts, {
  totalMoney: {
    required: true
  },
  taxMoney: {
    required: true
  },
  discountMoney: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.Amounts);
/**
 * SOURCE FeatureDetails @ squareup/client/bills/cart.proto at 127:3
 */
Cart.FeatureDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails');
fixType(Cart.FeatureDetails);
Builder.createAndAttachToType(Cart.FeatureDetails);
/**
 * Unused. Will never be used in the future.
 *
 * SOURCE Order @ squareup/client/bills/cart.proto at 130:5
 */
Cart.FeatureDetails.Order = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.Order');
fixType(Cart.FeatureDetails.Order);
Builder.createAndAttachToType(Cart.FeatureDetails.Order);
/**
 * SOURCE OpenTicket @ squareup/client/bills/cart.proto at 139:5
 */
Cart.FeatureDetails.OpenTicket = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OpenTicket');
fixType(Cart.FeatureDetails.OpenTicket, {
  ticketIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket);
/**
 * The predefined ticket details associated with this open ticket.
 *
 * Merchants can create predefined ticket groups and ticket templates to implement a rudimentary form of table management.
 * A ticket group has many ticket templates.  Ticket groups would be something like "Bar" or "Patio", while ticket templates
 * would be something like "Table 1", "Bar 2", etc.
 *
 * Even with predefined tickets enabled, merchants can create "custom" tickets that do not have a ticket template.  These custom
 * tickets can still have a ticket group.  Think of a custom ticket named "Guy In Red Shirt" assigned to the ticket group "Bar"
 * (because he left his credit card at the bar).
 *
 * SOURCE PredefinedTicket @ squareup/client/bills/cart.proto at 186:7
 */
Cart.FeatureDetails.OpenTicket.PredefinedTicket = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OpenTicket.PredefinedTicket');
fixType(Cart.FeatureDetails.OpenTicket.PredefinedTicket);
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.PredefinedTicket);
/**
 * Product-specific open ticket-level associations.
 *
 * SOURCE OpenTicketProductAssociation @ squareup/client/bills/cart.proto at 210:7
 */
Cart.FeatureDetails.OpenTicket.OpenTicketProductAssociation = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.OpenTicket.OpenTicketProductAssociation').values;
/**
 * Contains details on the reservation the OpenTicket is tied to. This is only intended to be used for Restaurants Reservations.
 *
 * SOURCE ReservationInformation @ squareup/client/bills/cart.proto at 244:8
 */
Cart.FeatureDetails.OpenTicket.ReservationInformation = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation');
fixType(Cart.FeatureDetails.OpenTicket.ReservationInformation);
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.ReservationInformation);
/**
 * SOURCE ReservationNotes @ squareup/client/bills/cart.proto at 269:9
 */
Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes');
fixType(Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes);
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.ReservationInformation.ReservationNotes);
/**
 * SOURCE Deposit @ squareup/client/bills/cart.proto at 301:9
 */
Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit');
fixType(Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit, {
  depositAmount: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.OpenTicket.ReservationInformation.Deposit);
/**
 * SOURCE Invoice @ squareup/client/bills/cart.proto at 329:5
 */
Cart.FeatureDetails.Invoice = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.Invoice');
fixType(Cart.FeatureDetails.Invoice, {
  invoiceIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.Invoice);
/**
 * Contains the identifier and version of an order if there is one associated with the invoice.
 *
 * SOURCE AssociatedOrder @ squareup/client/bills/cart.proto at 355:7
 */
Cart.FeatureDetails.Invoice.AssociatedOrder = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.Invoice.AssociatedOrder');
fixType(Cart.FeatureDetails.Invoice.AssociatedOrder);
Builder.createAndAttachToType(Cart.FeatureDetails.Invoice.AssociatedOrder);
/**
 * SOURCE KitchenPrinting @ squareup/client/bills/cart.proto at 367:5
 */
Cart.FeatureDetails.KitchenPrinting = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.KitchenPrinting');
fixType(Cart.FeatureDetails.KitchenPrinting, {
  name: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.KitchenPrinting);
/**
 * Additional details if the sale has a card on file attached, currently this is used only when a customer added.
 *
 * SOURCE InstrumentDetails @ squareup/client/bills/cart.proto at 376:5
 */
Cart.FeatureDetails.InstrumentDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.InstrumentDetails');
fixType(Cart.FeatureDetails.InstrumentDetails, {
  instrumentToken: {
    required: true,
    notEmpty: true
  },
  displayDetails: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.InstrumentDetails);
/**
 * Denormalized instrument data for better client performance.
 *
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 385:7
 */
Cart.FeatureDetails.InstrumentDetails.DisplayDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.InstrumentDetails.DisplayDetails');
fixType(Cart.FeatureDetails.InstrumentDetails.DisplayDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.InstrumentDetails.DisplayDetails);
/**
 * SOURCE BuyerInfo @ squareup/client/bills/cart.proto at 398:5
 */
Cart.FeatureDetails.BuyerInfo = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.BuyerInfo');
fixType(Cart.FeatureDetails.BuyerInfo, {
  customerId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.BuyerInfo);
/**
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 406:7
 */
Cart.FeatureDetails.BuyerInfo.DisplayDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.BuyerInfo.DisplayDetails');
fixType(Cart.FeatureDetails.BuyerInfo.DisplayDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.BuyerInfo.DisplayDetails);
/**
 * SOURCE AppointmentsDetails @ squareup/client/bills/cart.proto at 465:5
 */
Cart.FeatureDetails.AppointmentsDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.AppointmentsDetails');
fixType(Cart.FeatureDetails.AppointmentsDetails, {
  appointmentId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.AppointmentsDetails);
/**
 * Ticket information used to track information about feature details such as
 * coursing and seating when tickets are split & merged.
 *
 * SOURCE SourceTicketInformation @ squareup/client/bills/cart.proto at 495:5
 */
Cart.FeatureDetails.SourceTicketInformation = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.SourceTicketInformation');
fixType(Cart.FeatureDetails.SourceTicketInformation, {
  clientId: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.SourceTicketInformation);
/**
 * SOURCE CoursingOptions @ squareup/client/bills/cart.proto at 500:5
 */
Cart.FeatureDetails.CoursingOptions = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.CoursingOptions');
fixType(Cart.FeatureDetails.CoursingOptions);
Builder.createAndAttachToType(Cart.FeatureDetails.CoursingOptions);
/**
 * SOURCE Course @ squareup/client/bills/cart.proto at 501:7
 */
Cart.FeatureDetails.CoursingOptions.Course = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.CoursingOptions.Course');
fixType(Cart.FeatureDetails.CoursingOptions.Course, {
  courseIdPair: {
    required: true
  },
  straightFire: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.CoursingOptions.Course);
/**
 * SOURCE Event @ squareup/client/bills/cart.proto at 519:9
 */
Cart.FeatureDetails.CoursingOptions.Course.Event = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.CoursingOptions.Course.Event');
fixType(Cart.FeatureDetails.CoursingOptions.Course.Event, {
  eventIdPair: {
    required: true
  },
  eventType: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.CoursingOptions.Course.Event);
/**
 * SOURCE EventType @ squareup/client/bills/cart.proto at 520:11
 */
Cart.FeatureDetails.CoursingOptions.Course.Event.EventType = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.CoursingOptions.Course.Event.EventType').values;
/**
 * SOURCE Seating @ squareup/client/bills/cart.proto at 588:5
 */
Cart.FeatureDetails.Seating = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.Seating');
fixType(Cart.FeatureDetails.Seating);
Builder.createAndAttachToType(Cart.FeatureDetails.Seating);
/**
 * SOURCE Seat @ squareup/client/bills/cart.proto at 589:7
 */
Cart.FeatureDetails.Seating.Seat = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.Seating.Seat');
fixType(Cart.FeatureDetails.Seating.Seat, {
  seatIdPair: {
    required: true
  },
  ordinal: {
    required: true
  },
  enabled: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.Seating.Seat);
/**
 * Maintains information about whether the ticket has been printed as a bill. This only considers the most recently printed bill (by client wall clock).
 *
 * A bill is considered printed when the total amount on the bill when it was last printed matches the current total amount. See design doc for more details.
 *
 * https://docs.google.com/document/d/115dO-1al2zSpQVoW7SjVfDjQBMd1X_Dd-eR1e94gViM/edit#
 *
 * SOURCE BillPrintState @ squareup/client/bills/cart.proto at 636:5
 */
Cart.FeatureDetails.BillPrintState = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.BillPrintState');
fixType(Cart.FeatureDetails.BillPrintState);
Builder.createAndAttachToType(Cart.FeatureDetails.BillPrintState);
/**
 * Contains display details for carts representing re-opened tickets.
 *
 * SOURCE ReopenDetails @ squareup/client/bills/cart.proto at 658:5
 */
Cart.FeatureDetails.ReopenDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.ReopenDetails');
fixType(Cart.FeatureDetails.ReopenDetails, {
  reopenedAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.ReopenDetails);
/**
 * Per-tender display details--type, total money, and (optional) instrument info.
 *
 * SOURCE TenderDisplayDetails @ squareup/client/bills/cart.proto at 663:7
 */
Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails');
fixType(Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails, {
  type: {
    required: true
  },
  totalMoney: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.ReopenDetails.TenderDisplayDetails);
/**
 * Contains details about how a cover count is changed on a RST open ticket during its lifecycle.
 *
 * SOURCE CoverCountEvent @ squareup/client/bills/cart.proto at 687:5
 */
Cart.FeatureDetails.CoverCountEvent = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.CoverCountEvent');
fixType(Cart.FeatureDetails.CoverCountEvent, {
  eventId: {
    required: true
  },
  eventType: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.CoverCountEvent);
/**
 * SOURCE EventType @ squareup/client/bills/cart.proto at 688:7
 */
Cart.FeatureDetails.CoverCountEvent.EventType = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.CoverCountEvent.EventType').values;
/**
 * Contains reference to the payment device containing the pre-authed card for the new feature Auth and Delayed Capture (i.e opening a bar tab).
 *
 * SOURCE AuthAndDelayedCapture @ squareup/client/bills/cart.proto at 736:5
 */
Cart.FeatureDetails.AuthAndDelayedCapture = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.AuthAndDelayedCapture');
fixType(Cart.FeatureDetails.AuthAndDelayedCapture);
Builder.createAndAttachToType(Cart.FeatureDetails.AuthAndDelayedCapture);
/**
 * This was used by early RST clients for the Caviar integration pilot since we didn't have a canonical way to represent
 * Order data on a Bill. Now that Orders are stored directly on the bill this message is no longer used.
 *
 * SOURCE RSTOrderMetadata @ squareup/client/bills/cart.proto at 748:5
 */
Cart.FeatureDetails.RSTOrderMetadata = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.RSTOrderMetadata');
fixType(Cart.FeatureDetails.RSTOrderMetadata);
Builder.createAndAttachToType(Cart.FeatureDetails.RSTOrderMetadata);
/**
 * SOURCE Fulfillment @ squareup/client/bills/cart.proto at 752:7
 */
Cart.FeatureDetails.RSTOrderMetadata.Fulfillment = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.RSTOrderMetadata.Fulfillment');
fixType(Cart.FeatureDetails.RSTOrderMetadata.Fulfillment);
Builder.createAndAttachToType(Cart.FeatureDetails.RSTOrderMetadata.Fulfillment);
/**
 * SOURCE FulfillmentEntry @ squareup/client/bills/cart.proto at 759:9
 */
Cart.FeatureDetails.RSTOrderMetadata.Fulfillment.FulfillmentEntry = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.RSTOrderMetadata.Fulfillment.FulfillmentEntry');
fixType(Cart.FeatureDetails.RSTOrderMetadata.Fulfillment.FulfillmentEntry);
Builder.createAndAttachToType(Cart.FeatureDetails.RSTOrderMetadata.Fulfillment.FulfillmentEntry);
/**
 * SOURCE LifecycleEvent @ squareup/client/bills/cart.proto at 789:5
 */
Cart.FeatureDetails.LifecycleEvent = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.LifecycleEvent');
fixType(Cart.FeatureDetails.LifecycleEvent, {
  eventIdPair: {
    required: true
  },
  eventType: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.LifecycleEvent);
/**
 * SOURCE EventType @ squareup/client/bills/cart.proto at 792:7
 */
Cart.FeatureDetails.LifecycleEvent.EventType = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.LifecycleEvent.EventType').values;
/**
 * SOURCE OwnershipTransferDetails @ squareup/client/bills/cart.proto at 829:7
 */
Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails');
fixType(Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails, {
  transferToEmployee: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.LifecycleEvent.OwnershipTransferDetails);
/**
 * Information about the OMG Order that manages fulfillment for this cart.
 *
 * SOURCE OrderDetails @ squareup/client/bills/cart.proto at 852:5
 */
Cart.FeatureDetails.OrderDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OrderDetails');
fixType(Cart.FeatureDetails.OrderDetails, {
  fulfillmentCreationDetails: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.OrderDetails);
/**
 * Fulfillment details for this cart. Note that this is only used for initial creation of
 * the fulfillment. UIs should instead render the Order itself post-creation, which can be
 * retrieved using the order_id field.
 *
 * SOURCE FulfillmentCreationDetails @ squareup/client/bills/cart.proto at 858:7
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails');
fixType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails, {
  recipient: {
    required: true
  },
  items: {
    required: true
  },
  type: {
    required: true
  },
  state: {
    required: true
  },
  locationId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails);
/**
 * Additional information for PICKUP fulfillments.
 *
 * SOURCE FulfillmentPickupDetails @ squareup/client/bills/cart.proto at 861:9
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails');
fixType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails);
/**
 * Specific details for curbside pickup.
 *
 * SOURCE CurbsidePickupDetails @ squareup/client/bills/cart.proto at 864:11
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails.CurbsidePickupDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails.CurbsidePickupDetails');
fixType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails.CurbsidePickupDetails, {
  curbsideDetails: {
    required: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails.CurbsidePickupDetails);
/**
 * SOURCE ScheduleType @ squareup/client/bills/cart.proto at 871:11
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails.ScheduleType = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentPickupDetails.ScheduleType').values;
/**
 * Additional information for DELIVERY fulfillments.
 *
 * SOURCE FulfillmentDeliveryDetails @ squareup/client/bills/cart.proto at 900:9
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentDeliveryDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentDeliveryDetails');
fixType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentDeliveryDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentDeliveryDetails);
/**
 * SOURCE ScheduleType @ squareup/client/bills/cart.proto at 901:11
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentDeliveryDetails.ScheduleType = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentDeliveryDetails.ScheduleType').values;
/**
 * SOURCE FulfillmentRecipient @ squareup/client/bills/cart.proto at 919:9
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentRecipient = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentRecipient');
fixType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentRecipient);
Builder.createAndAttachToType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentRecipient);
/**
 * SOURCE FulfillmentItems @ squareup/client/bills/cart.proto at 959:9
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentItems = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentItems');
fixType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentItems, {
  lineItemClientId: {
    notEmpty: true
  },
  quantity: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentItems);
/**
 * SOURCE FulfillmentType @ squareup/client/bills/cart.proto at 971:9
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentType = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentType').values;
/**
 * The state of the fulfillment. Fulfillments can only be created in the NEW or COMPLETED
 * state, and only a single fulfillment per order may be NEW.
 *
 * In order to support cart <-> order conversions on client, the remaining fulfillment
 * states (RESERVED, PREPARED, CANCELED, and FAILED) are included here. However, the client
 * will not use these states when creating / updating fulfillments via bills.
 *
 * SOURCE FulfillmentState @ squareup/client/bills/cart.proto at 988:9
 */
Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentState = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.OrderDetails.FulfillmentCreationDetails.FulfillmentState').values;
/**
 * Pricing engine state tied to a cart.
 *
 * SOURCE PricingEngineState @ squareup/client/bills/cart.proto at 1059:5
 */
Cart.FeatureDetails.PricingEngineState = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.PricingEngineState');
fixType(Cart.FeatureDetails.PricingEngineState);
Builder.createAndAttachToType(Cart.FeatureDetails.PricingEngineState);
/**
 * Pickup details for this sale.
 *
 * SOURCE BuyerNotificationDetails @ squareup/client/bills/cart.proto at 1088:6
 */
Cart.FeatureDetails.BuyerNotificationDetails = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.BuyerNotificationDetails');
fixType(Cart.FeatureDetails.BuyerNotificationDetails);
Builder.createAndAttachToType(Cart.FeatureDetails.BuyerNotificationDetails);
/**
 * Channels for the bill
 *
 * SOURCE Channel @ squareup/client/bills/cart.proto at 1104:5
 */
Cart.FeatureDetails.Channel = $root.lookupType('squareup.client.bills.Cart.FeatureDetails.Channel');
fixType(Cart.FeatureDetails.Channel);
Builder.createAndAttachToType(Cart.FeatureDetails.Channel);
/**
 * SOURCE Type @ squareup/client/bills/cart.proto at 1117:7
 */
Cart.FeatureDetails.Channel.Type = $root.lookupEnum('squareup.client.bills.Cart.FeatureDetails.Channel.Type').values;
/**
 * SOURCE ReturnLineItems @ squareup/client/bills/cart.proto at 1154:3
 */
Cart.ReturnLineItems = $root.lookupType('squareup.client.bills.Cart.ReturnLineItems');
fixType(Cart.ReturnLineItems);
Builder.createAndAttachToType(Cart.ReturnLineItems);
/**
 * SOURCE ReturnItemization @ squareup/client/bills/cart.proto at 1162:5
 */
Cart.ReturnLineItems.ReturnItemization = $root.lookupType('squareup.client.bills.Cart.ReturnLineItems.ReturnItemization');
fixType(Cart.ReturnLineItems.ReturnItemization);
Builder.createAndAttachToType(Cart.ReturnLineItems.ReturnItemization);
/**
 * Contains both the total return amount and total sale amount in the bill.
 *
 * SOURCE AmountDetails @ squareup/client/bills/cart.proto at 1212:3
 */
Cart.AmountDetails = $root.lookupType('squareup.client.bills.Cart.AmountDetails');
fixType(Cart.AmountDetails);
Builder.createAndAttachToType(Cart.AmountDetails);
/**
 * Demarcates a return as either Linked or Unlinked
 *
 * SOURCE ReturnType @ squareup/client/bills/cart.proto at 1252:4
 */
Cart.ReturnType = $root.lookupEnum('squareup.client.bills.Cart.ReturnType').values;
/**
 * Individual itemization on the bill.
 * This is an item and associated taxes, discounts, etc.
 *
 * Example: If there is $1 total tax two items, each itemization will have $0.50 tax.
 * The latter will be reflected in this individual itemization. Other calculations are more complex.
 *
 * For calculation details and rounding rules, refer to: https://go.sqprod.co/itemizations
 *
 * SOURCE Itemization @ squareup/client/bills/cart.proto at 1278:1
 */
export const Itemization = $root.lookupType('squareup.client.bills.Itemization');
fixType(Itemization, {
  itemizationIdPair: {
    required: true
  },
  quantity: {
    required: true
  },
  configuration: {
    required: true
  },
  amounts: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization);
/**
 * How the quantity was added to the itemization
 *
 * SOURCE QuantityEntryType @ squareup/client/bills/cart.proto at 1300:3
 */
Itemization.QuantityEntryType = $root.lookupEnum('squareup.client.bills.Itemization.QuantityEntryType').values;
/**
 * SOURCE Configuration @ squareup/client/bills/cart.proto at 1339:3
 */
Itemization.Configuration = $root.lookupType('squareup.client.bills.Itemization.Configuration');
fixType(Itemization.Configuration, {
  selectedOptions: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Configuration);
/**
 * SOURCE SelectedOptions @ squareup/client/bills/cart.proto at 1340:5
 */
Itemization.Configuration.SelectedOptions = $root.lookupType('squareup.client.bills.Itemization.Configuration.SelectedOptions');
fixType(Itemization.Configuration.SelectedOptions);
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions);
/**
 * SOURCE ItemVariationDetails @ squareup/client/bills/cart.proto at 1341:7
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails = $root.lookupType('squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails);
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails);
/**
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 1344:9
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails = $root.lookupType('squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails, {
  priceMoney: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.DisplayDetails);
/**
 * SOURCE BackingDetails @ squareup/client/bills/cart.proto at 1362:9
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails = $root.lookupType('squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails);
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.BackingDetails);
/**
 * Additional details for a gift card itemization.
 *
 * SOURCE GiftCardDetails @ squareup/client/bills/cart.proto at 1385:9
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails = $root.lookupType('squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails');
fixType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails, {
  activityType: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails);
/**
 * Action taken on the gift card, e.g. balance reload, new activation, etc.
 *
 * SOURCE ActivityType @ squareup/client/bills/cart.proto at 1395:11
 */
Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails.ActivityType = $root.lookupEnum('squareup.client.bills.Itemization.Configuration.SelectedOptions.ItemVariationDetails.GiftCardDetails.ActivityType').values;
/**
 * The backing data type used to create the itemization.
 *
 * SOURCE BackingType @ squareup/client/bills/cart.proto at 1470:5
 */
Itemization.Configuration.BackingType = $root.lookupEnum('squareup.client.bills.Itemization.Configuration.BackingType').values;
/**
 * SOURCE BackingDetails @ squareup/client/bills/cart.proto at 1523:3
 */
Itemization.BackingDetails = $root.lookupType('squareup.client.bills.Itemization.BackingDetails');
fixType(Itemization.BackingDetails);
Builder.createAndAttachToType(Itemization.BackingDetails);
/**
 * SOURCE AvailableOptions @ squareup/client/bills/cart.proto at 1532:5
 */
Itemization.BackingDetails.AvailableOptions = $root.lookupType('squareup.client.bills.Itemization.BackingDetails.AvailableOptions');
fixType(Itemization.BackingDetails.AvailableOptions);
Builder.createAndAttachToType(Itemization.BackingDetails.AvailableOptions);
/**
 * SOURCE ModifierList @ squareup/client/bills/cart.proto at 1536:7
 */
Itemization.BackingDetails.AvailableOptions.ModifierList = $root.lookupType('squareup.client.bills.Itemization.BackingDetails.AvailableOptions.ModifierList');
fixType(Itemization.BackingDetails.AvailableOptions.ModifierList);
Builder.createAndAttachToType(Itemization.BackingDetails.AvailableOptions.ModifierList);
/**
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 1564:3
 */
Itemization.DisplayDetails = $root.lookupType('squareup.client.bills.Itemization.DisplayDetails');
fixType(Itemization.DisplayDetails);
Builder.createAndAttachToType(Itemization.DisplayDetails);
/**
 * Details from the original item used to create the itemization.
 *
 * SOURCE Item @ squareup/client/bills/cart.proto at 1569:5
 */
Itemization.DisplayDetails.Item = $root.lookupType('squareup.client.bills.Itemization.DisplayDetails.Item');
fixType(Itemization.DisplayDetails.Item);
Builder.createAndAttachToType(Itemization.DisplayDetails.Item);
/**
 * SOURCE MenuCategory @ squareup/client/bills/cart.proto at 1584:5
 */
Itemization.DisplayDetails.MenuCategory = $root.lookupType('squareup.client.bills.Itemization.DisplayDetails.MenuCategory');
fixType(Itemization.DisplayDetails.MenuCategory);
Builder.createAndAttachToType(Itemization.DisplayDetails.MenuCategory);
/**
 * SOURCE Amounts @ squareup/client/bills/cart.proto at 1596:3
 */
Itemization.Amounts = $root.lookupType('squareup.client.bills.Itemization.Amounts');
fixType(Itemization.Amounts, {
  itemVariationPriceMoney: {
    required: true
  },
  itemVariationPriceTimesQuantityMoney: {
    required: true
  },
  discountMoney: {
    required: true
  },
  taxMoney: {
    required: true
  },
  totalMoney: {
    required: true
  },
  surchargeMoney: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Amounts);
/**
 * SOURCE Event @ squareup/client/bills/cart.proto at 1693:3
 */
Itemization.Event = $root.lookupType('squareup.client.bills.Itemization.Event');
fixType(Itemization.Event, {
  eventIdPair: {
    required: true
  },
  eventType: {
    required: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Event);
/**
 * Clients MUST be forward compatible with any new event types defined in the future,
 * that is, to handle unknown new event types gracefully without crashes.
 *
 * SOURCE EventType @ squareup/client/bills/cart.proto at 1703:5
 */
Itemization.Event.EventType = $root.lookupEnum('squareup.client.bills.Itemization.Event.EventType').values;
/**
 * An itemization split occurs when comping/voiding partial quantity of an
 * existing itemization or splitting/moving an itemization into another ticket.
 *
 * The child itemizations' Itemization.created_at should be set to the parent
 * splitting itemization's Itemization.created_at to preserve order in the list.
 *
 * SOURCE SplitEventDetails @ squareup/client/bills/cart.proto at 1842:5
 */
Itemization.Event.SplitEventDetails = $root.lookupType('squareup.client.bills.Itemization.Event.SplitEventDetails');
fixType(Itemization.Event.SplitEventDetails);
Builder.createAndAttachToType(Itemization.Event.SplitEventDetails);
/**
 * SOURCE ChildItemization @ squareup/client/bills/cart.proto at 1843:7
 */
Itemization.Event.SplitEventDetails.ChildItemization = $root.lookupType('squareup.client.bills.Itemization.Event.SplitEventDetails.ChildItemization');
fixType(Itemization.Event.SplitEventDetails.ChildItemization, {
  ticketIdPair: {
    required: true
  },
  childItemizationIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Event.SplitEventDetails.ChildItemization);
/**
 * Addition information for all KDS events.
 *
 * SOURCE KdsEventDetails @ squareup/client/bills/cart.proto at 1863:5
 */
Itemization.Event.KdsEventDetails = $root.lookupType('squareup.client.bills.Itemization.Event.KdsEventDetails');
fixType(Itemization.Event.KdsEventDetails);
Builder.createAndAttachToType(Itemization.Event.KdsEventDetails);
/**
 * A reference to an itemization on a different ticket.
 *
 * SOURCE ItemizationReference @ squareup/client/bills/cart.proto at 1890:6
 */
Itemization.Event.ItemizationReference = $root.lookupType('squareup.client.bills.Itemization.Event.ItemizationReference');
fixType(Itemization.Event.ItemizationReference, {
  ticketTokenPair: {
    required: true
  },
  itemizationTokenPair: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.Event.ItemizationReference);
/**
 * SOURCE FeatureDetails @ squareup/client/bills/cart.proto at 1909:3
 */
Itemization.FeatureDetails = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails');
fixType(Itemization.FeatureDetails);
Builder.createAndAttachToType(Itemization.FeatureDetails);
/**
 * Collection of boolean states that can be parsed to understand how to display, hide, or otherwise
 * represent this item on differently configure Kitchen Displays.
 *
 * SOURCE KitchenDisplay @ squareup/client/bills/cart.proto at 1916:5
 */
Itemization.FeatureDetails.KitchenDisplay = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.KitchenDisplay');
fixType(Itemization.FeatureDetails.KitchenDisplay);
Builder.createAndAttachToType(Itemization.FeatureDetails.KitchenDisplay);
/**
 * SOURCE Seating @ squareup/client/bills/cart.proto at 1933:5
 */
Itemization.FeatureDetails.Seating = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.Seating');
fixType(Itemization.FeatureDetails.Seating);
Builder.createAndAttachToType(Itemization.FeatureDetails.Seating);
/**
 * SOURCE Destination @ squareup/client/bills/cart.proto at 1934:7
 */
Itemization.FeatureDetails.Seating.Destination = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.Seating.Destination');
fixType(Itemization.FeatureDetails.Seating.Destination, {
  seatIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.FeatureDetails.Seating.Destination);
/**
 * SOURCE Type @ squareup/client/bills/cart.proto at 1935:9
 */
Itemization.FeatureDetails.Seating.Destination.Type = $root.lookupEnum('squareup.client.bills.Itemization.FeatureDetails.Seating.Destination.Type').values;
/**
 * SOURCE AppointmentsServiceDetails @ squareup/client/bills/cart.proto at 1964:5
 */
Itemization.FeatureDetails.AppointmentsServiceDetails = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.AppointmentsServiceDetails');
fixType(Itemization.FeatureDetails.AppointmentsServiceDetails, {
  serviceId: {
    required: true
  },
  ordinal: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.FeatureDetails.AppointmentsServiceDetails);
/**
 * SOURCE ResourceDetails @ squareup/client/bills/cart.proto at 1989:7
 */
Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails');
fixType(Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails);
Builder.createAndAttachToType(Itemization.FeatureDetails.AppointmentsServiceDetails.ResourceDetails);
/**
 * Metadata about an Itemization that was created from a previous itemization.
 * This should be populated whenever an itemization is created from another itemization (e.g. in a reopen or split).
 * Events should be copied in full, without modification, when an itemization is created from a previous itemization.
 *
 * SOURCE InheritedItemizationDetails @ squareup/client/bills/cart.proto at 2017:5
 */
Itemization.FeatureDetails.InheritedItemizationDetails = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.InheritedItemizationDetails');
fixType(Itemization.FeatureDetails.InheritedItemizationDetails, {
  inheritedEventIdPairs: {
    required: true
  },
  createReason: {
    required: true
  }
});
Builder.createAndAttachToType(Itemization.FeatureDetails.InheritedItemizationDetails);
/**
 * Indicates what caused this itemization to be created.
 *
 * SOURCE CreateReason @ squareup/client/bills/cart.proto at 2025:7
 */
Itemization.FeatureDetails.InheritedItemizationDetails.CreateReason = $root.lookupEnum('squareup.client.bills.Itemization.FeatureDetails.InheritedItemizationDetails.CreateReason').values;
/**
 * Pricing engine state tied to an itemization.
 *
 * SOURCE PricingEngineState @ squareup/client/bills/cart.proto at 2040:5
 */
Itemization.FeatureDetails.PricingEngineState = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.PricingEngineState');
fixType(Itemization.FeatureDetails.PricingEngineState);
Builder.createAndAttachToType(Itemization.FeatureDetails.PricingEngineState);
/**
 * SOURCE SignInType @ squareup/client/bills/cart.proto at 2067:5
 */
Itemization.FeatureDetails.SignInType = $root.lookupEnum('squareup.client.bills.Itemization.FeatureDetails.SignInType').values;
/**
 * Extensions for item-splitting-specific features
 *
 * SOURCE LineItemSplitDetails @ squareup/client/bills/cart.proto at 2082:5
 */
Itemization.FeatureDetails.LineItemSplitDetails = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.LineItemSplitDetails');
fixType(Itemization.FeatureDetails.LineItemSplitDetails);
Builder.createAndAttachToType(Itemization.FeatureDetails.LineItemSplitDetails);
/**
 * SOURCE LineItemPricing @ squareup/client/bills/cart.proto at 2092:7
 */
Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing = $root.lookupType('squareup.client.bills.Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing');
fixType(Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing);
Builder.createAndAttachToType(Itemization.FeatureDetails.LineItemSplitDetails.LineItemPricing);
/**
 * SOURCE EmployeeAttribution @ squareup/client/bills/cart.proto at 2125:3
 */
Itemization.EmployeeAttribution = $root.lookupType('squareup.client.bills.Itemization.EmployeeAttribution');
fixType(Itemization.EmployeeAttribution);
Builder.createAndAttachToType(Itemization.EmployeeAttribution);
/**
 * Discounts, fees, dining options can apply at either the cart-level or the itemization-level.
 * Adding this field to a LineItem allows us to have specific business logic for handling
 * different rules for cart level vs override fields.
 *
 * When deriving top level rollups, and a mixture of ITEMIZATION_LEVEL & CART_LEVEL exist,
 * the client should prefer CART_LEVEL in order to ensure that newly added itemizations will
 * also receive the line_item associated with this ApplicationScope.
 *
 * SOURCE ApplicationScope @ squareup/client/bills/cart.proto at 2149:1
 */
export const ApplicationScope = $root.lookupEnum('squareup.client.bills.ApplicationScope').values;
/**
 * SOURCE DiscountLineItem @ squareup/client/bills/cart.proto at 2200:1
 */
export const DiscountLineItem = $root.lookupType('squareup.client.bills.DiscountLineItem');
fixType(DiscountLineItem, {
  discountLineItemIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(DiscountLineItem);
/**
 * SOURCE Configuration @ squareup/client/bills/cart.proto at 2210:3
 */
DiscountLineItem.Configuration = $root.lookupType('squareup.client.bills.DiscountLineItem.Configuration');
fixType(DiscountLineItem.Configuration);
Builder.createAndAttachToType(DiscountLineItem.Configuration);
/**
 * SOURCE BackingDetails @ squareup/client/bills/cart.proto at 2219:3
 */
DiscountLineItem.BackingDetails = $root.lookupType('squareup.client.bills.DiscountLineItem.BackingDetails');
fixType(DiscountLineItem.BackingDetails, {
  discount: {
    required: true
  }
});
Builder.createAndAttachToType(DiscountLineItem.BackingDetails);
/**
 * Some services (i.e. invoices, retail) want to reference discounts that
 * are not from the items service.
 *
 * SOURCE BackingType @ squareup/client/bills/cart.proto at 2237:5
 */
DiscountLineItem.BackingDetails.BackingType = $root.lookupEnum('squareup.client.bills.DiscountLineItem.BackingDetails.BackingType').values;
/**
 * Details from the original discount used to create the discount line item.
 *
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 2275:3
 */
DiscountLineItem.DisplayDetails = $root.lookupType('squareup.client.bills.DiscountLineItem.DisplayDetails');
fixType(DiscountLineItem.DisplayDetails, {
  name: {
    required: true
  },
  cogsObjectId: {
    required: true
  }
});
Builder.createAndAttachToType(DiscountLineItem.DisplayDetails);
/**
 * SOURCE Amounts @ squareup/client/bills/cart.proto at 2306:3
 */
DiscountLineItem.Amounts = $root.lookupType('squareup.client.bills.DiscountLineItem.Amounts');
fixType(DiscountLineItem.Amounts, {
  appliedMoney: {
    required: true
  }
});
Builder.createAndAttachToType(DiscountLineItem.Amounts);
/**
 * This field tracks how a DiscountLineItem was added to the cart, whether by a person or by
 * matching a pricing rule.
 *
 * SOURCE ApplicationMethod @ squareup/client/bills/cart.proto at 2339:3
 */
DiscountLineItem.ApplicationMethod = $root.lookupEnum('squareup.client.bills.DiscountLineItem.ApplicationMethod').values;
/**
 * SOURCE FeeLineItem @ squareup/client/bills/cart.proto at 2384:1
 */
export const FeeLineItem = $root.lookupType('squareup.client.bills.FeeLineItem');
fixType(FeeLineItem, {
  feeLineItemIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(FeeLineItem);
/**
 * SOURCE BackingDetails @ squareup/client/bills/cart.proto at 2394:3
 */
FeeLineItem.BackingDetails = $root.lookupType('squareup.client.bills.FeeLineItem.BackingDetails');
fixType(FeeLineItem.BackingDetails, {
  fee: {
    required: true
  }
});
Builder.createAndAttachToType(FeeLineItem.BackingDetails);
/**
 * Some services (i.e. retail, LST) reference fees that are not stored in the items service.
 * BackingType provides a way to differentiate these custom fees from those in the items service.
 *
 * SOURCE BackingType @ squareup/client/bills/cart.proto at 2403:5
 */
FeeLineItem.BackingDetails.BackingType = $root.lookupEnum('squareup.client.bills.FeeLineItem.BackingDetails.BackingType').values;
/**
 * Details from the original fee used to create the fee line item.
 *
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 2432:3
 */
FeeLineItem.DisplayDetails = $root.lookupType('squareup.client.bills.FeeLineItem.DisplayDetails');
fixType(FeeLineItem.DisplayDetails, {
  name: {
    required: true
  },
  calculationPhase: {
    required: true
  },
  inclusionType: {
    required: true
  },
  cogsObjectId: {
    required: true
  }
});
Builder.createAndAttachToType(FeeLineItem.DisplayDetails);
/**
 * SOURCE Amounts @ squareup/client/bills/cart.proto at 2472:3
 */
FeeLineItem.Amounts = $root.lookupType('squareup.client.bills.FeeLineItem.Amounts');
fixType(FeeLineItem.Amounts, {
  appliedMoney: {
    required: true
  }
});
Builder.createAndAttachToType(FeeLineItem.Amounts);
/**
 * Describes how the FeeLineItem was applied to the cart.
 *
 * SOURCE ApplicationMethod @ squareup/client/bills/cart.proto at 2528:3
 */
FeeLineItem.ApplicationMethod = $root.lookupEnum('squareup.client.bills.FeeLineItem.ApplicationMethod').values;
/**
 * SOURCE ModifierOptionLineItem @ squareup/client/bills/cart.proto at 2552:1
 */
export const ModifierOptionLineItem = $root.lookupType('squareup.client.bills.ModifierOptionLineItem');
fixType(ModifierOptionLineItem, {
  amounts: {
    required: true
  }
});
Builder.createAndAttachToType(ModifierOptionLineItem);
/**
 * SOURCE Amounts @ squareup/client/bills/cart.proto at 2556:3
 */
ModifierOptionLineItem.Amounts = $root.lookupType('squareup.client.bills.ModifierOptionLineItem.Amounts');
fixType(ModifierOptionLineItem.Amounts, {
  modifierOptionMoney: {
    required: true
  },
  modifierOptionTimesQuantityMoney: {
    required: true
  }
});
Builder.createAndAttachToType(ModifierOptionLineItem.Amounts);
/**
 * Details from the original modifier option used to create the modifier option line item.
 *
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 2584:3
 */
ModifierOptionLineItem.DisplayDetails = $root.lookupType('squareup.client.bills.ModifierOptionLineItem.DisplayDetails');
fixType(ModifierOptionLineItem.DisplayDetails, {
  sortOrder: {
    required: true
  },
  cogsObjectId: {
    required: true
  }
});
Builder.createAndAttachToType(ModifierOptionLineItem.DisplayDetails);
/**
 * SOURCE BackingDetails @ squareup/client/bills/cart.proto at 2601:3
 */
ModifierOptionLineItem.BackingDetails = $root.lookupType('squareup.client.bills.ModifierOptionLineItem.BackingDetails');
fixType(ModifierOptionLineItem.BackingDetails, {
  backingModifierOption: {
    required: true
  }
});
Builder.createAndAttachToType(ModifierOptionLineItem.BackingDetails);
/**
 * SOURCE FeatureDetails @ squareup/client/bills/cart.proto at 2621:3
 */
ModifierOptionLineItem.FeatureDetails = $root.lookupType('squareup.client.bills.ModifierOptionLineItem.FeatureDetails');
fixType(ModifierOptionLineItem.FeatureDetails);
Builder.createAndAttachToType(ModifierOptionLineItem.FeatureDetails);
/**
 * SOURCE ConversationalMode @ squareup/client/bills/cart.proto at 2622:5
 */
ModifierOptionLineItem.FeatureDetails.ConversationalMode = $root.lookupType('squareup.client.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode');
fixType(ModifierOptionLineItem.FeatureDetails.ConversationalMode);
Builder.createAndAttachToType(ModifierOptionLineItem.FeatureDetails.ConversationalMode);
/**
 * SOURCE Type @ squareup/client/bills/cart.proto at 2623:7
 */
ModifierOptionLineItem.FeatureDetails.ConversationalMode.Type = $root.lookupEnum('squareup.client.bills.ModifierOptionLineItem.FeatureDetails.ConversationalMode.Type').values;
/**
 * Quantity of the modifier on the itemization.
 * Current: Integer quantity. e.g. 0, 1, or 2
 * Future: Decimal quantity. e.g. 1.0 or 0.5 or 3.5
 *
 * SOURCE Quantities @ squareup/client/bills/cart.proto at 2653:5
 */
ModifierOptionLineItem.FeatureDetails.Quantities = $root.lookupType('squareup.client.bills.ModifierOptionLineItem.FeatureDetails.Quantities');
fixType(ModifierOptionLineItem.FeatureDetails.Quantities);
Builder.createAndAttachToType(ModifierOptionLineItem.FeatureDetails.Quantities);
/**
 * SOURCE RoundingAdjustmentLineItem @ squareup/client/bills/cart.proto at 2679:1
 */
export const RoundingAdjustmentLineItem = $root.lookupType('squareup.client.bills.RoundingAdjustmentLineItem');
fixType(RoundingAdjustmentLineItem, {
  calculationPhase: {
    required: true
  },
  amounts: {
    required: true
  },
  roundingAdjustmentLineItemIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(RoundingAdjustmentLineItem);
/**
 * SOURCE Amounts @ squareup/client/bills/cart.proto at 2682:3
 */
RoundingAdjustmentLineItem.Amounts = $root.lookupType('squareup.client.bills.RoundingAdjustmentLineItem.Amounts');
fixType(RoundingAdjustmentLineItem.Amounts, {
  appliedMoney: {
    required: true
  }
});
Builder.createAndAttachToType(RoundingAdjustmentLineItem.Amounts);
/**
 * SOURCE DiningOptionLineItem @ squareup/client/bills/cart.proto at 2699:1
 */
export const DiningOptionLineItem = $root.lookupType('squareup.client.bills.DiningOptionLineItem');
fixType(DiningOptionLineItem, {
  diningOptionLineItemIdPair: {
    required: true
  },
  backingDetails: {
    required: true
  },
  applicationScope: {
    required: true
  }
});
Builder.createAndAttachToType(DiningOptionLineItem);
/**
 * SOURCE BackingDetails @ squareup/client/bills/cart.proto at 2706:3
 */
DiningOptionLineItem.BackingDetails = $root.lookupType('squareup.client.bills.DiningOptionLineItem.BackingDetails');
fixType(DiningOptionLineItem.BackingDetails, {
  diningOption: {
    required: true
  }
});
Builder.createAndAttachToType(DiningOptionLineItem.BackingDetails);
/**
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 2717:3
 */
DiningOptionLineItem.DisplayDetails = $root.lookupType('squareup.client.bills.DiningOptionLineItem.DisplayDetails');
fixType(DiningOptionLineItem.DisplayDetails);
Builder.createAndAttachToType(DiningOptionLineItem.DisplayDetails);
/**
 * There's no TipLineItem in sales cart. It is represented implicitly in tender because tip is strongly tied to tender.
 * There's TipLineItem in return cart because there's no strong tie to a refund.
 *
 * SOURCE TipLineItem @ squareup/client/bills/cart.proto at 2727:1
 */
export const TipLineItem = $root.lookupType('squareup.client.bills.TipLineItem');
fixType(TipLineItem, {
  tipLineItemIdPair: {
    required: true
  }
});
Builder.createAndAttachToType(TipLineItem);
/**
 * SOURCE Amounts @ squareup/client/bills/cart.proto at 2731:3
 */
TipLineItem.Amounts = $root.lookupType('squareup.client.bills.TipLineItem.Amounts');
fixType(TipLineItem.Amounts, {
  appliedMoney: {
    required: true
  }
});
Builder.createAndAttachToType(TipLineItem.Amounts);
/**
 * SOURCE SurchargeLineItem @ squareup/client/bills/cart.proto at 2741:1
 */
export const SurchargeLineItem = $root.lookupType('squareup.client.bills.SurchargeLineItem');
fixType(SurchargeLineItem);
Builder.createAndAttachToType(SurchargeLineItem);
/**
 * SOURCE BackingDetails @ squareup/client/bills/cart.proto at 2746:3
 */
SurchargeLineItem.BackingDetails = $root.lookupType('squareup.client.bills.SurchargeLineItem.BackingDetails');
fixType(SurchargeLineItem.BackingDetails);
Builder.createAndAttachToType(SurchargeLineItem.BackingDetails);
/**
 * Surcharges may be defined adhoc (i.e. CUSTOM) or by the items service.
 *
 * SOURCE BackingType @ squareup/client/bills/cart.proto at 2752:5
 */
SurchargeLineItem.BackingDetails.BackingType = $root.lookupEnum('squareup.client.bills.SurchargeLineItem.BackingDetails.BackingType').values;
/**
 * SOURCE Amounts @ squareup/client/bills/cart.proto at 2769:3
 */
SurchargeLineItem.Amounts = $root.lookupType('squareup.client.bills.SurchargeLineItem.Amounts');
fixType(SurchargeLineItem.Amounts);
Builder.createAndAttachToType(SurchargeLineItem.Amounts);
/**
 * Pricing engine state tied to a SurchargeLineItem.
 *
 * SOURCE PricingEngineState @ squareup/client/bills/cart.proto at 2783:3
 */
SurchargeLineItem.PricingEngineState = $root.lookupType('squareup.client.bills.SurchargeLineItem.PricingEngineState');
fixType(SurchargeLineItem.PricingEngineState);
Builder.createAndAttachToType(SurchargeLineItem.PricingEngineState);
/**
 * How the apportioned surcharge was applied to the cart.
 *
 * SOURCE ApplicationMethod @ squareup/client/bills/cart.proto at 2827:3
 */
SurchargeLineItem.ApplicationMethod = $root.lookupEnum('squareup.client.bills.SurchargeLineItem.ApplicationMethod').values;
/**
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 2861:3
 */
SurchargeLineItem.DisplayDetails = $root.lookupType('squareup.client.bills.SurchargeLineItem.DisplayDetails');
fixType(SurchargeLineItem.DisplayDetails);
Builder.createAndAttachToType(SurchargeLineItem.DisplayDetails);
/**
 * SOURCE GroupLineItem @ squareup/client/bills/cart.proto at 2868:1
 */
export const GroupLineItem = $root.lookupType('squareup.client.bills.GroupLineItem');
fixType(GroupLineItem);
Builder.createAndAttachToType(GroupLineItem);
/**
 * SOURCE Configuration @ squareup/client/bills/cart.proto at 2874:3
 */
GroupLineItem.Configuration = $root.lookupType('squareup.client.bills.GroupLineItem.Configuration');
fixType(GroupLineItem.Configuration);
Builder.createAndAttachToType(GroupLineItem.Configuration);
/**
 * SOURCE ComboConfiguration @ squareup/client/bills/cart.proto at 2875:5
 */
GroupLineItem.Configuration.ComboConfiguration = $root.lookupType('squareup.client.bills.GroupLineItem.Configuration.ComboConfiguration');
fixType(GroupLineItem.Configuration.ComboConfiguration);
Builder.createAndAttachToType(GroupLineItem.Configuration.ComboConfiguration);
/**
 * SOURCE ItemizationGroup @ squareup/client/bills/cart.proto at 2886:1
 */
export const ItemizationGroup = $root.lookupType('squareup.client.bills.ItemizationGroup');
fixType(ItemizationGroup);
Builder.createAndAttachToType(ItemizationGroup);
/**
 * SOURCE Type @ squareup/client/bills/cart.proto at 2892:3
 */
ItemizationGroup.Type = $root.lookupEnum('squareup.client.bills.ItemizationGroup.Type').values;
/**
 * SOURCE BackingDetails @ squareup/client/bills/cart.proto at 2899:3
 */
ItemizationGroup.BackingDetails = $root.lookupType('squareup.client.bills.ItemizationGroup.BackingDetails');
fixType(ItemizationGroup.BackingDetails);
Builder.createAndAttachToType(ItemizationGroup.BackingDetails);
/**
 * SOURCE MerchantCatalogObjects @ squareup/client/bills/cart.proto at 2903:5
 */
ItemizationGroup.BackingDetails.MerchantCatalogObjects = $root.lookupType('squareup.client.bills.ItemizationGroup.BackingDetails.MerchantCatalogObjects');
fixType(ItemizationGroup.BackingDetails.MerchantCatalogObjects);
Builder.createAndAttachToType(ItemizationGroup.BackingDetails.MerchantCatalogObjects);
/**
 * SOURCE DisplayDetails @ squareup/client/bills/cart.proto at 2911:3
 */
ItemizationGroup.DisplayDetails = $root.lookupType('squareup.client.bills.ItemizationGroup.DisplayDetails');
fixType(ItemizationGroup.DisplayDetails);
Builder.createAndAttachToType(ItemizationGroup.DisplayDetails);
/**
 * SOURCE ComboChoice @ squareup/client/bills/cart.proto at 2916:5
 */
ItemizationGroup.DisplayDetails.ComboChoice = $root.lookupType('squareup.client.bills.ItemizationGroup.DisplayDetails.ComboChoice');
fixType(ItemizationGroup.DisplayDetails.ComboChoice);
Builder.createAndAttachToType(ItemizationGroup.DisplayDetails.ComboChoice);
/**
 * SOURCE ValidationDetails @ squareup/client/bills/cart.proto at 2921:7
 */
ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails = $root.lookupType('squareup.client.bills.ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails');
fixType(ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails);
Builder.createAndAttachToType(ItemizationGroup.DisplayDetails.ComboChoice.ValidationDetails);
/**
 * There's no TipLineItem in sales cart. It is represented implicitly in tender because tip is strongly tied to tender.
 * There's TipLineItem in return cart because there's no strong tie to a refund.
 *
 * SOURCE ReturnTipLineItem @ squareup/client/bills/cart.proto at 2941:1
 */
export const ReturnTipLineItem = $root.lookupType('squareup.client.bills.ReturnTipLineItem');
fixType(ReturnTipLineItem);
Builder.createAndAttachToType(ReturnTipLineItem);
/**
 * SOURCE ReturnSurchargeLineItem @ squareup/client/bills/cart.proto at 2952:1
 */
export const ReturnSurchargeLineItem = $root.lookupType('squareup.client.bills.ReturnSurchargeLineItem');
fixType(ReturnSurchargeLineItem);
Builder.createAndAttachToType(ReturnSurchargeLineItem);